import * as ActionTypes from '../constants/ActionTypes';
import { ActionCreator } from '../utils/flux';

/**
 * @class ServerRequestActions
 * @extends ActionCreator
 */
export default class ServerRequestActions extends ActionCreator {
    constructor(options) {
        super(options);

        this.api = options.api;
    }

    /**
     * @param {TimesGridState} state
     * @param {Array<moment>} dates
     */
    fetchTimes(state, dates) {
        return Promise.all([
            this.api.getTimes({
                ...state,
                isExistingPatient: true,
            }, dates),
            this.api.getTimes({
                ...state,
                isExistingPatient: false,
            }, dates),
        ])
            .then(this.allTimesReceived)
            .catch(this.encounteredError);
    }

    allTimesReceived = () => {
        return this.dispatch({
            actionType: ActionTypes.ALL_TIMES_RECEIVED,
        });
    };

    encounteredError = error => {
        this.dispatch({
            actionType: ActionTypes.SERVER_ERROR,
            error,
        });
    };
}
